import React from 'react';
import { OrbitComponentWithState } from '../../base-components/orbit-component-with-state/orbit-component-with-state';
import { observer } from 'mobx-react';
import { FoundGamesComponent } from "./found-games/found-games.component";
import { SuggestedLinksComponent } from "./suggested-links/suggested-links.component";
import { SearchFormResultsBox } from "./boxes/search-form-results-box/search-form-results.box";
import { SearchFormResultsWrapperBox } from "./boxes/search-form-results-wrapper-box/search-form-results-wrapper.box";
import { SuggestedGamesComponent } from './suggested-games/suggested-games.component';


export interface ISearchResultComponentState {
    loadedGames: number;
}

const LOAD_BATCH_SIZE = 12;

const defaultState: ISearchResultComponentState = {
    loadedGames: LOAD_BATCH_SIZE
}

@observer
export class SearchResultComponent extends OrbitComponentWithState<{}, ISearchResultComponentState> {

    state = {...defaultState};

    componentDidMount() {
        super.componentDidMount();
        this.reaction(() => this.services.gameSearch.currentSearchText, () => {
            this._resetState();
        })
    }

    private _onLoadMore = () => {
        this.services.analytics.sendAnalytics('Search', 'Entry', 'Show_More');
        const moreItems = Math.min(this.state.loadedGames + LOAD_BATCH_SIZE, this.services.gameSearch.searchResult.games.length);
        this.setState({
            loadedGames: moreItems
        });
    }

    private _resetState() {
        this.setState({...defaultState});
    }

    _renderSearchResults() {
        if (this.services.gameSearch.isSearchInProgress) {
            return (
                <>
                    <FoundGamesComponent loadedGamesCount={this.state.loadedGames} onLoadMore={this._onLoadMore}/>
                    {this.services.miniOrbit.isEnabled ? null : <SuggestedLinksComponent title={'SUGGESTED_CATEGORIES'} className={'cy-suggested-links-suggested-links'} items={this.services.gameSearch.searchResult.suggestedCategories} />}
                </>
            );
        } else {
            return (
                <>
                    <SuggestedGamesComponent items={this.services.gameSearch.searchResult.suggestedGames} />
                    {this.services.miniOrbit.isEnabled ? null : <SuggestedLinksComponent title={'QUICK_LINKS_TITLE'} className={'cy-suggested-links-quick-links'} items={this.services.gameSearch.searchResult.suggestedCategories} />}
                </>
            );
        }
    }

    render() {
        if (!this.services.gameSearch.isSearchBoxOpened) {
            return null;
        }

        const isHybridAndroid = this.services.device.hybrid.isHybrid && !this.services.device.os.isIOS;

        return (
            <SearchFormResultsBox isHybridAndroid={isHybridAndroid && this.services.mediaQuery.portrait} ref={this.services.gameSearch.searchResultComponentRef}>
                <SearchFormResultsWrapperBox>
                    {this._renderSearchResults()}
                </SearchFormResultsWrapperBox>
            </SearchFormResultsBox>
        );
    }
}
